import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'migo-apps-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent implements OnInit {
  message = '';
  title = '';
  confirmText = '';
  cancelText = '';

  constructor(@Inject(MAT_DIALOG_DATA) private data: any) {}

  ngOnInit(): void {
    this.title = this.data?.title ? this.data.title : 'Confirmar';
    this.message = this.data?.message ? this.data.message : '¿Estás seguro?';
    this.confirmText = this.data?.confirmText ? this.data.confirmText : 'Si';
    this.cancelText = this.data?.cancelText ? this.data.cancelText : 'No';
  }
}
